import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { CurrentTenantService } from '../services/current-tenant.service';

export const currentTenantGuard: CanActivateFn = async () => {
  const currentTenantService = inject(CurrentTenantService);
  const router = inject(Router);

  if (currentTenantService.currentTenantId()) {
    return true;
  }

  await router.navigate(['/select-tenant']);

  return false;
};
